export default {
      id: "rosneft-usage",
      viewBox: "0 0 125 80",
      url: __webpack_public_path__ + "sprite.svg#rosneft-usage",
      toString: function () {
        return this.url;
      }
    }